import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';

import { environment } from '../../../environments/environment';

const apiUrl = '/auth/refresh';
const apiPlayUrl = '/play/auth/refresh';
let serviceCode = '';
serviceCode = environment.serviceCode;

@Injectable()
export class AuthRefreshService {

  constructor(private http: Http) { }

  execute(): Observable<any> {
    const baseUrl = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + apiPlayUrl;
    const url = baseUrl + apiUrl;

    const headers = new Headers({
      'Content-Type': 'application/json',
      'x-api-key': localStorage.getItem('apiKey'),
      'x-service-code': serviceCode,
      'x-session-key': (JSON.parse(sessionStorage.getItem('loginResult')))['sessionKey'],
      'x-csrf-token': (JSON.parse(sessionStorage.getItem('loginResult')))['csrfToken']
    });

    const jsonInput = {
      refreshKey: (JSON.parse(sessionStorage.getItem('loginResult')))['refreshKey']
    };

    return this.http
      .post(url, JSON.stringify(jsonInput), {headers: headers})
      .map(response => response.json() as any)
      .catch(error => {
        console.log('AuthRefreshService.execute error');
        return Promise.reject(error);
      });
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/auth-refresh/auth-refresh.service.ts